import { apiFetch, postJson } from './apiClient';
import {
  AdminCreateUserRequest,
  AdminCreateUserResponse,
  AdminUpdateUserRequest,
  Guid,
  PagedResult,
  UserAuditRecord,
  UserDetails,
  UserListQuery,
  UserSummary,
  UserStatusUpdateRequest,
} from '../types/userManagement';

const BASE_PATH = '/api/v1/admin/users';

function toQueryString(query: UserListQuery): string {
  const parameters = new URLSearchParams({
    page: String(query.page),
    pageSize: String(query.pageSize),
  });

  if (query.search) parameters.set('search', query.search);
  if (query.status) parameters.set('status', query.status);
  if (query.role) parameters.set('role', query.role);
  if (query.brandingId) parameters.set('brandingId', query.brandingId);

  return parameters.toString();
}

export const userManagementApi = {
  getUsers: (query: UserListQuery) =>
    apiFetch<PagedResult<UserSummary>>(`${BASE_PATH}?${toQueryString(query)}`),
  getUser: (userId: Guid) => apiFetch<UserDetails>(`${BASE_PATH}/${userId}`),
  createUser: (request: AdminCreateUserRequest) =>
    postJson<AdminCreateUserResponse>(BASE_PATH, request),
  updateUser: (userId: Guid, request: AdminUpdateUserRequest) =>
    apiFetch<unknown>(`${BASE_PATH}/${userId}`, {
      method: 'PUT',
      body: JSON.stringify(request),
    }),
  resendInvite: (userId: Guid) => postJson<void>(`${BASE_PATH}/${userId}/resend-invite`),
  updateStatus: (userId: Guid, request: UserStatusUpdateRequest) =>
    postJson<void>(`${BASE_PATH}/${userId}/status`, request),
  unlock: (userId: Guid) => postJson<void>(`${BASE_PATH}/${userId}/unlock`),
  forceReset: (userId: Guid) => postJson<void>(`${BASE_PATH}/${userId}/force-reset`),
  getAudit: (userId: Guid) => apiFetch<UserAuditRecord[]>(`${BASE_PATH}/${userId}/audit`),
};